import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Main from "../../../layout/main/Main";
import { Form, Spin } from "antd";
import { AntdButton, DistributorContainer, InnerForm } from "./styles";
import { Typo } from "../../../layout/theme";
import {
	get_client_by_id,
	update_client_distributors,
	update_laboratory_distributors,
} from "../../../../api/endpoints/clients";
import DistributorsSelectorConfig from "../../../common/distributos-selector-config/DistributorsSelectorConfig";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";

export default function LaboratoryConfigs({ clientId }) {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [form] = Form.useForm();
	const [submitting, setSubmitting] = useState(false);
	const [initialValues, setInitialValues] = useState(null);
	const [distributors, setDistributors] = useState(null);
	const [flag, setFlag] = useState(false);

	useEffect(() => {
		const fetch_client_by_id = async () => {
			setSubmitting(true);
			try {
				const data = await get_client_by_id(clientId);

				const client = {
					name: data.client.name,
					cuit: data.client.cuit,
					businessName: data.client.businessName,
					client: data.client.isSeller === true ? "Laboratorio" : "Farmacia",
					address: data.client.address,
					postalCode: data.client.postalCode,
					glnAnmat: data.client.glnAnmat,
					isSeller: data.client.isSeller,
					contactEmail: data.client.contactEmail,
					contactFirstName: data.client.contactName?.split(/(\s+)/)[0],
					contactLastName: data.client.contactName?.split(/(\s+)/)[2],
					contactId: data.client.users.find((u) => u.isFirstUser === true).id,
					phone: data.client.contactPhone?.slice(
						3,
						data.client.contactPhone.length
					),
					phoneAreaCode: data.client.contactPhone?.slice(0, 2),
					state: data.client.deleted === false ? "ACTIVE" : "DELETED",
					typeOfSale: data.client.typeOfSale,
					generalDiscount: data.client.generalDiscount,
					tier: data.client.tier,
					isApproved: data.client.isApproved,
					megaDistributorCode: data.client.megaDistributorCode,
					biller: data.client.biller,
					commercialActionCode: data.client.commercialActionCode,
					clientEmails: data.client.clientEmails,
					mobileRemitentMail: data.client.mobileRemitentMail,
					alertCopyMail: data.client.alertCopyMail,
				};

				setDistributors(data.distributors);
				setInitialValues(client);
			} catch (error) {
			} finally {
				setSubmitting(false);
			}
		};

		if (clientId) {
			fetch_client_by_id();
		}
	}, [flag]);

	const onFinish = async (values) => {
		setSubmitting(true);
		try {
			const newDistributor = distributors.map((d) =>
				d.checked === true ? { ...d, code: "si" } : { ...d, code: null }
			);
			const data = {
				id: clientId,
				distributors: newDistributor.map((d) => ({
					id: d.id,
					code: d.code,
					selectedMail: d.selectedMail,
					externalName: d.externalName,
					eanAutocomplete: d.eanAutocomplete,
				})),
			};
			await update_laboratory_distributors(data);
			setFlag(!flag);
			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Configuracion editada con exito",
				"La configuracion se edito con exito"
			);
		} catch (error) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Error al editar configuracion",
				"Un error ocurrio al intentar editar las configuraciones, contacte con soporte a soporte@checkpos.com."
			);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Configuraciones</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				{!initialValues && !distributors ? (
					<Spin />
				) : (
					<Form
						form={form}
						name="basic"
						onFinish={onFinish}
						autoComplete="off"
						requiredMark={false}
						layout="vertical"
						initialValues={initialValues}
					>
						<InnerForm>
							<DistributorContainer>
								<Typo type="primary" level={4}>
									Configuraciones droguerias
								</Typo>
								<Form.Item name="distributors">
									<DistributorsSelectorConfig
										onChange={setDistributors}
										initialValues={distributors}
										clientId={clientId}
									/>
								</Form.Item>
							</DistributorContainer>
							<Form.Item>
								<AntdButton
									type="primary"
									htmlType="submit"
									loading={submitting}
									width={200}
								>
									Guardar
								</AntdButton>
							</Form.Item>
						</InnerForm>
					</Form>
				)}
			</Main.Body>
		</Main>
	);
}
